import { BPM_DEFAULT, DEFAULT_SEED, MASTER_VOLUME_DEFAULT } from "../audio/constants";
import type { UserControls } from "./types";

/**
 * Defaults per docs/implementation-plan.md ch.5 and 3.13:
 *  - manual BPM at 96, auto tempo OFF (nothing but the user changes tempo)
 *  - quiet master volume
 *  - diagnostic click ON in Phase 0 so the signal path is audible on first run
 */
export function createDefaultControls(seed: string = DEFAULT_SEED): UserControls {
  return {
    transport: {
      bpmManual: BPM_DEFAULT,
      autoTempo: false,
    },
    // An even three-way blend is the honest default: this project is about the
    // space between the genres, not about starting inside one of them.
    genre: { ambient: 34, techno: 33, jazz: 33 },
    main: { energy: 0.5, density: 0.5 },
    sound: {
      masterVolume: MASTER_VOLUME_DEFAULT,
      muted: false,
    },
    // Phase 1A: the music itself is the signal now, so the diagnostic click is
    // off by default. It stays available to prove the scheduling path.
    diagnosticClick: false,
    seed,
  };
}

/** Reads `?seed=` so a session can be reproduced from a URL. */
export function seedFromLocation(search: string): string {
  const params = new URLSearchParams(search);
  const seed = params.get("seed");
  return seed !== null && seed.length > 0 ? seed : DEFAULT_SEED;
}
